<template>
  <div id="insideRecommend">
    <HR v-if="authority"></HR>
    <user v-else></user>
  </div>
</template>

<script>
import api from '@/apis/inside'
import HR from './HR/index.vue'
import user from './user/index.vue'
export default {
  components: {
    HR,
    user
  },
  data() {
    return {
      salaryInfo: {},
      authority: true,
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      if (this.$route.query.authority) {
        this.authority = JSON.parse(this.$route.query.authority)
      } else {
        this.initHomePage()
      }
    },
    //获取权限
    initHomePage() {
      this.salaryInfo = JSON.parse(localStorage.getItem("salaryInfo"));
      api.selectHrName({
        empNo: this.salaryInfo.empNo
      }).then((res) => {
        if (res.code == 200) {
          this.authority = res.data.hrPosition == 1 ? true : false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>

$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  #insideRecommend {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  #insideRecommend {
    width: 276px * $zoom;
  }
}
#insideRecommend {
  font-size: 16px * $zoom;
  position: relative;
}
</style>
